import Repository from "@/repositories/RepositoryFactory";
import APISTATE from "../../enums/APISTATE";

let openResolve, openReject;

const reports = Repository.get("reports");

export default {
  namespaced: true,
  state: {
    groupMembers: [],
    availableGroupMembers: [],
    isOpen: false,
    filter: {}
  },
  mutations: {
    setChosenAssistant(state, assistantNumber) {
      const index = state.groupMembers.findIndex(
        (gm) => gm.number == assistantNumber
      );
      if (index !== -1) {
        state.groupMembers[index].isSelected = true;
      }

      state.availableGroupMembers[
        state.availableGroupMembers.findIndex(
          (gm) => gm.number == assistantNumber
        )
      ].isSelected = true;
    },
    setRejectedAssistant(state, assistantNumber) {
      const index = state.groupMembers.findIndex(
        (gm) => gm.number == assistantNumber
      );
      if (index !== -1) {
        state.groupMembers[index].isSelected = false;
      }

      state.availableGroupMembers[
        state.availableGroupMembers.findIndex(
          (gm) => gm.number == assistantNumber
        )
      ].isSelected = false;
    },
    setIsOpen(state, isOpen) {
      state.isOpen = isOpen;
    },
    setGroupMembers(state, response) {
      state.groupMembers = response;
      state.apiState = APISTATE.LOADED;
    },
    setAvailableGroupMembers(state, response) {
      state.availableGroupMembers = response;
    },
    setFilter(state, filter) {
      state.filter = filter
    }
  },
  actions: {
    async sidebarOpenAsync({ commit}) {
      commit("setIsOpen", true);
      return new Promise((resolve, reject) => {
        openResolve = resolve;
        openReject = reject;
      });
    },
    markAssistantNumber({ commit, state }, assistantNumber) {
      const specificAssistant = state.groupMembers.find(
        (gm) => gm.number === assistantNumber
      );
      specificAssistant.isSelected
        ? commit("setRejectedAssistant", assistantNumber)
        : commit("setChosenAssistant", assistantNumber);
    },
    rejectAll({ commit, state }) {
      state.availableGroupMembers.forEach((agm) => {
        commit("setRejectedAssistant", agm.number);
      });
    },
    sidebarCancel: ({ commit, state }) => {
      if (openResolve instanceof Function) {
        openResolve({
          action: "cancel",
          markedGroupMembers: [],
        });
      }
      commit("setIsOpen", false);
    },
    setIsOpen: ({ commit }) => {
      commit("setIsOpen", true);
    },
    updateParentView: ({ commit, state }) => {
      if (openResolve instanceof Function) {
        openResolve({
          action: "update",
          markedGroupMembers: state.availableGroupMembers.filter(
            (gm) => gm.isSelected
          ),
        });
      }
      commit("setIsOpen", false);
    },
    searchForEmployee: ({ commit, state }, searchTerm) => {
      let groupMembers;
      if (searchTerm === "") {
        groupMembers = state.availableGroupMembers;
      } else {
        groupMembers = state.availableGroupMembers.filter(
          (gm) =>
            gm.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            gm.number
              .toString()
              .toLowerCase()
              .includes(searchTerm.toLowerCase())
        );
      }

      if (groupMembers === undefined) {
        commit("setGroupMembers", []);
      } else {
        commit("setGroupMembers",  groupMembers );
      }
    },
    setGroupMembers({commit, state}, groupMembers){
      commit("setGroupMembers", groupMembers);
      commit("setAvailableGroupMembers", groupMembers);
      // state.groupMembers.forEach((elem) => {
      //   commit("setChosenAssistant", elem.number);
      // });
    },
    setFilter({commit}, filter){
      commit("setFilter", filter);
    }
  },
  getters: {
    groupMembers: (state) => state.groupMembers,
    isOpen: (state) => state.isOpen,
    filter: (state) => state.filter,
    availableGroupMembers: (state) => state.availableGroupMembers
  },
};
